import { adminAction, getType } from '../../redux/actions/index';

const initialState = {
    reportMonth1: {},
    reportMonth2: {},
    viewRoom: {
        "roomTotal": 0,
        "capacity": 0,
        "femaleTotal": 0,
        "memberShipTotal": 0,
        "companyTotal": 0,
        "pickUpTotal": 0,
        "dropOffTotal": 0,
        "fromAzAppTotal": 0,
        "fromAzWebTotal": 0,
        "cancelListTotal": 0,
        "surveyTotal": 0,
        "waitingListTotal": 0,
        "OTATotal": 0,
        "OTATotalDetails": {
            "booking.com": 0,
            "agoda": 0,
            "expedia": 0,
            "hafh": 0,
            "trip.com": 0,
            "rakuten": 0
        },
        "content": [],
        "branchInformation": {
            "name": "",
            "room": 0
        }
    },
    memberShip:{
    },
    monthSelect1: "",
    monthSelect2: "",
    tabMenuSelect: "OneBranch",
    typeTabMenuSelect: "REPORT BRANCH", // Canlender, Tabletl
    isLoading: true,
}

const reportTotalReducer = (state = initialState, action) => {
    switch (action.type) {
        case getType(adminAction.fetchAdminReportTotal): {
            return action.payload;
        }
        case getType(adminAction.fetchAdminReportTotalWithTarget): {
            const { data, target} = action.payload;
            const newInti = {...state};
            newInti[target] = {...data};
            newInti.isLoading = false;
            // if(target === "viewRoom") {
            //     newInti[target].percent = Math.round(((data.roomTotal / (data.content.length * data.branchInformation.room) )* 10000)) /100
            // } 
            
            return newInti;
        }
        case getType(adminAction.resetAdminReportTotal): {
            return initialState;
        }
        case getType(adminAction.resetAdminReportTotalWithTraget): {
            const { target, typeTabMenuSelect } = action.payload;
            if(target === "viewRoom") {
                return {
                    ...initialState,
                    typeTabMenuSelect,
                    viewRoom: {
                        "roomTotal": 0,
                        "capacity": 0,
                        "femaleTotal": 0,
                        "memberShipTotal": 0,
                        "companyTotal": 0,
                        "pickUpTotal": 0,
                        "dropOffTotal": 0,
                        "fromAzAppTotal": 0,
                        "fromAzWebTotal": 0,
                        "cancelListTotal": 0,
                        "surveyTotal": 0,
                        "waitingListTotal": 0,
                        "OTATotal": 0,
                        "OTATotalDetails": {
                            "booking.com": 0,
                            "agoda": 0,
                            "expedia": 0,
                            "hafh": 0,
                            "trip.com": 0,
                            "rakuten": 0
                        },
                        "content": [],
                        "branchInformation": {
                            "name": "",
                            "room": 0
                        }
                    },
                    isLoading: false,
                }
            } 
        }
        case getType(adminAction.editAdminReportTotal): {
            const { target, value, index } = action.payload;

            const newData = {...initialState}
            newData[target] = value;
            return newData;
        }
        default: return state;
    }
}
    
export default reportTotalReducer;
